import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from '@/components/app/routes';
import WxCopilotHost from '@/components/pages/wx-copilot-host';
import { AccessDenied } from '@/components/ui/access-denied';
import { ErrorStateFallback } from '@/components/ui/error-state';
import { Spinner } from '@/components/ui/spinner';
import { useAuthContext } from '@/contexts/auth-context';
import { domainMeta } from '@/utils/domain-meta';
import { fullstorySnippetString } from '@/utils/fullstory';
import {
  getAndClearIntendedDestination,
  saveIntendedDestination,
} from '@/utils/intended-destination';

const SIGNIN_URL = `${domainMeta.monolithOrigin}/users/sign_in?redirect=source`;

export function App() {
  const { isAuthenticated, isLoading, hasSourceAccess } = useAuthContext();
  const navigate = useNavigate();
  const [hasCheckedDestination, setHasCheckedDestination] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !hasCheckedDestination) {
      const intendedDestination = getAndClearIntendedDestination();
      if (intendedDestination) {
        const url = new URL(intendedDestination, window.location.origin);
        navigate(url.pathname + url.search, { replace: true });
      }
      setHasCheckedDestination(true);
    }
  }, [isAuthenticated, hasCheckedDestination, navigate]);

  if (isLoading) return <Spinner />;

  if (!isAuthenticated) {
    saveIntendedDestination();
    window.location.href = SIGNIN_URL;
    return <Spinner />;
  }

  if (!hasSourceAccess) return <AccessDenied />;

  return (
    <ErrorStateFallback>
      <Helmet>
        <script>{fullstorySnippetString}</script>
      </Helmet>
      <WxCopilotHost />
      <AppRoutes />
    </ErrorStateFallback>
  );
}
